import { Injectable } from "@angular/core";
import { Subject, ReplaySubject } from 'rxjs';
import { Profile } from '../models/profile.model';
import { Status } from '../models/state.model';

@Injectable({
    providedIn: 'root',
})
export class StateService {
    constructor() {
        this.savedState = new Subject<string>();
        this.currentProfile = new Subject<Profile>();
        this.currentStatus = new ReplaySubject<Status>();
    }
    savedState: Subject<string>;
    currentProfile: Subject<Profile>;
    currentStatus: ReplaySubject<Status>;
}